import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect } from "react";
import classnames from "classnames";
import Snackbar from "@mui/material/Snackbar";
import { Portal } from "../Portal/index.js";
import { useStyles } from "./Snackbar.styles.js";
const Snackbar_Snackbar = (t0)=>{
    const $ = c(19);
    const { open, message, action, className, variant: t1, zPosition: t2, hideMessage } = t0;
    const variant = void 0 === t1 ? "static" : t1;
    const zPosition = void 0 === t2 ? "top" : t2;
    const { classes } = useStyles();
    let t3;
    let t4;
    if ($[0] !== open) {
        t3 = ()=>{
            const webimButtonCorner = Array.from(document.getElementsByClassName("webim-button-corner"))[0];
            if (webimButtonCorner) if (open) webimButtonCorner.classList.add("webim-button-corner-button");
            else webimButtonCorner.classList.remove("webim-button-corner-button");
            const webimChat = document.getElementById("webim_chat");
            if (webimChat) if (open) webimChat.classList.add("webim-chat-button");
            else webimChat.classList.remove("webim-chat-button");
            return ()=>{
                if (webimButtonCorner) webimButtonCorner.classList.remove("webim-button-corner-button");
                if (webimChat) webimChat.classList.remove("webim-chat-button");
            };
        };
        t4 = [
            open
        ];
        $[0] = open;
        $[1] = t3;
        $[2] = t4;
    } else {
        t3 = $[1];
        t4 = $[2];
    }
    useEffect(t3, t4);
    let contentClassName = classes.snackbarContent;
    if ("sticky" === variant) contentClassName = classes.snackbarContentSticky;
    if ("top" === zPosition) contentClassName = classes.snackbarContentPositionTop;
    let t5;
    if ($[3] !== zPosition) {
        t5 = {
            vertical: zPosition,
            horizontal: "center"
        };
        $[3] = zPosition;
        $[4] = t5;
    } else t5 = $[4];
    const t6 = !message || hideMessage;
    let t7;
    if ($[5] !== className || $[6] !== classes.snackbar || $[7] !== classes.snackbarHideMessage || $[8] !== t6) {
        t7 = classnames(classes.snackbar, "aqa_snackbar", className, {
            [classes.snackbarHideMessage]: t6
        });
        $[5] = className;
        $[6] = classes.snackbar;
        $[7] = classes.snackbarHideMessage;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== contentClassName) {
        t8 = {
            className: contentClassName
        };
        $[10] = contentClassName;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== action || $[13] !== message || $[14] !== open || $[15] !== t5 || $[16] !== t7 || $[17] !== t8) {
        t9 = /*#__PURE__*/ jsx(Portal, {
            children: /*#__PURE__*/ jsx(Snackbar, {
                anchorOrigin: t5,
                className: t7,
                open: open,
                message: message,
                action: action,
                ContentProps: t8
            })
        });
        $[12] = action;
        $[13] = message;
        $[14] = open;
        $[15] = t5;
        $[16] = t7;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
};
export { Snackbar_Snackbar as Snackbar };
